import(/* webpackMode: "eager" */ "/codebuild/output/src659718568/src/ui-directo/apps/customer/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/codebuild/output/src659718568/src/ui-directo/apps/customer/src/redux/provider.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src659718568/src/ui-directo/node_modules/@mui/material-nextjs/v13-appRouter/appRouterV13.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src659718568/src/ui-directo/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src659718568/src/ui-directo/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src659718568/src/ui-directo/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src659718568/src/ui-directo/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src659718568/src/ui-directo/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
